import { Trans } from "react-i18next";
import { useEffect, useContext } from "react";
import Markdown from "react-markdown";
import "../utils/chatbotMarkDown.css";
import { ChatbotStateContext, ChatbotStateDispatchContext } from "../utils/chatbotContext";
import { useWebSocketContext } from "../utils/chatbotWSContext";


export const ChatbotStreamingResponse = ({ initials }: { initials: string | undefined }) => {

  const chatbotCurrentState = useContext(ChatbotStateContext);
  const dispatch = useContext(ChatbotStateDispatchContext);
  const { getConversationHistory } = useWebSocketContext();

  useEffect(() => {
    if (!chatbotCurrentState.isStreaming) {
      if (chatbotCurrentState.selectedConversationId === "") {
        dispatch({ type: "UPDATE_IS_CREATING", payload: true });
      }
      getConversationHistory(chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole);
    }
  }, [chatbotCurrentState.isStreaming, chatbotCurrentState.selectedConversationId, chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole, dispatch, getConversationHistory]);

  return (
    <>
      {/* Question */}
      <div className="w-full rounded-lg p-4 flex">
        <div>
          <div className="w-16 h-16 rounded-full mx-auto flex items-center outline outline-1 outline-ua-pink justify-center bg-white text-black font-unleashed">
            {initials || "N/A"}
          </div>
        </div>
        <div className="pl-4">
          <p className="font-bold font-unleashed ml-2"><Trans>You</Trans></p>
          <p className="pl-1 ml-1">{chatbotCurrentState.streamingQuestion}</p>
        </div>
      </div>
      {/* Response */}
      <div className="w-full rounded-lg p-4 flex">
        <div className="w-16 h-16 flex-shrink-0">
          <img
            src="/UB-Wingman-AI-Icon-No-Wings.png"
            alt="Wingman Avatar"
            className="w-full h-full rounded-full mx-auto"
          />
        </div>
        <div className="pl-4 flex-grow">
          <p className="font-bold font-unleashed ml-2"><Trans>Wingman</Trans></p>
          <div className="markdown-container">
            <Markdown>{chatbotCurrentState.streamingResponse}</Markdown>
          </div>
        </div>
      </div>
    </>
  );
};
